<!-- BR#167 Pop-up for MU/VC/MENA/Trader as requested on stop out level change 12/02/2025 Mbeng-->
   
<template>
  <div
    v-if="visible"
   class="popup-overlay"
  >
    <!-- Popup -->
    <div
      class="popup-content"
    >
      
      <div>
        <h2 style="font-weight:bold">Important Notice: Stop out level adjustment notice</h2><br>
        <p>Dear Valued client</p><br>
        <p>Please be informed that effective March 19, 2026, the stop out level will be</p>
        <p>increased from 0% to 5%.</p><br>
        <p>We kindly advise you to monitor your positions closely and ensure that your</p>
        <p>accounts are sufficiently funded to avoid reaching the stop out level.</p><br>
        <p>Best regards </p><br>
        
      <button
        @click="$emit('close')"
        class="text-white font-bold bg-opacity-50 hover:bg-opacity-80 rounded-full p-2 z-10"
        style="background-color: #004A81;"
      >
      ok
      </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LevelAdjustmentPopup",
    props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  emits: ["close"],
  data() {
    return {
    };
  },
  computed: {
     ...mapGetters(["get_profile", "get_user_data"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
  }
  },

};
</script>
<style scoped>
/* Simple popup styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
}
</style>
